export default __webpack_public_path__ + "static/media/111.34bd26c4.jpg";